import { render } from "./SliderAccueil.vue?vue&type=template&id=1884d7b7&scoped=true"
import script from "./SliderAccueil.vue?vue&type=script&lang=js"
export * from "./SliderAccueil.vue?vue&type=script&lang=js"

import "./SliderAccueil.vue?vue&type=style&index=0&id=1884d7b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1884d7b7"]])

export default __exports__